import React, { useEffect, useRef, useState } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import PropTypes from 'prop-types';

function SearchBar({ value, onChange }) {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  
  useEffect(() => {
    const handleKeyPress = (e) => {
      // Command/Ctrl + K to focus search
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        inputRef.current?.focus();
      }
      // Escape to clear and blur
      if (e.key === 'Escape' && document.activeElement === inputRef.current) {
        onChange('');
        inputRef.current?.blur();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [onChange]);

  const handleClear = () => {
    onChange('');
    inputRef.current?.focus();
  };

  return (
    <div className={`search-bar-container ${isFocused ? 'focused' : ''}`}>
      <FaSearch className="search-icon" />
      <input
        ref={inputRef}
        type="text"
        className="search-bar"
        placeholder="Search prompts..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      {value && (
        <button
          className="clear-button"
          onClick={handleClear}
          title="Clear search"
        >
          <FaTimes />
        </button>
      )}
      <div className="search-shortcut">⌘K</div>
    </div>
  );
}

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default SearchBar;